import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14.8418 9.99512C15.9688 10.9344 17.4182 11.5 19 11.5C20.5091 11.5 21.8968 10.984 23 10.1211V21H1V9.99512H14.8418ZM5.58594 13.4971L7.58594 15.4971L5.58594 17.4971L7 18.9121L10.4141 15.4971L7 12.083L5.58594 13.4971ZM12 18.4971H18V16.4971H12V18.4971Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.8145 3C12.6109 3.63014 12.5 4.30209 12.5 5C12.5 6.08435 12.7668 7.10604 13.2363 8.00488H1V3H12.8145Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20.4551 3.54395L23.6797 5L20.4551 6.45508L19 9.67969L17.5439 6.45508L14.3203 5L17.5439 3.54395L19 0.320312L20.4551 3.54395Z"}}]};

const AiTerminal1Filled = Vue.extend<IconProps>({
  name: 'AiTerminal1FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'ai-terminal-1-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default AiTerminal1Filled;
